module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedSemiBoldItalic.3d417d1.woff2";